export default __webpack_public_path__ + "static/media/journeytray-bluetree-fruitflower.73525ebc.svg";